(function($) {
    $('document').ready(function() {
        let lodgeFilter = $('#lodge-filter');
        if (lodgeFilter.length === 0) {
            // Abandon this script if target does not exist
            return;
        }

        let mixContainer = $('.lodges');
        let mixer = mixitup(mixContainer);

        // This is an error message if check out is more than 10 days after check in
        let bookingDateError = $('div#booking-date-error');

        // These are visible form fields on the lodging filter row
        let checkInDate = $('input#check-in-date');
        let checkOutDate = $('input#check-out-date');
        let numGuests = $('select#num-guests');

        // This is a hidden form for adding a lodge to an order
        const bookingForm = $('#lodging-booking');
        const productIdField = $('input.wc-booking-product-id');
        const addToCart = $('button[name="add-to-cart"]');

        // These are hidden form fields that get posted to the woocommerce booking plugin
        let checkInYear = $('input#wc_bookings_field_start_date_year');
        let checkInMonth = $('input#wc_bookings_field_start_date_month');
        let checkInDay = $('input#wc_bookings_field_start_date_day');
        let stayDuration = $('input#wc_bookings_field_duration');
        let numPersons = $('input#wc_bookings_field_persons');

        /*
         * This function fires whenever a visible form field is changed.
         *
         * The intention is that an availability query will only fire if
         * all 3 of check in, check out, and number of guests are all
         * selected.
         *
         * If all of those 3 parameters are present then the woocommerce
         * booked plugin API is queried for a list of "slots".
         *
         * This API returns each product for each day along with an
         * "available" and a "booked" flag. For this we're only really
         * concerned with availability, so if a product is unavailable
         * during any period of the response then it is excluded from
         * any final results.
         *
         * Additional filtering is used for guest occupancy because
         * the booking API has no parameter for filtering based on this.
         *
         * With a list of valid results, this then updates the hidden
         * input fields (see above) with what the user selected on the
         * dropdown (the visible fields).
         *
         * When the user clicks "add to my order" on any of the available
         * lodges then the hidden form is updated with that lodge's
         * post id, and a form submission is triggered
         * (see: submitForm function below)
         *
         */
        let handleCinChange = function () {
            if (typeof checkInDate.val() === 'undefined' || typeof checkOutDate.val() === 'undefined') {
                return;
            }

            if (checkInDate.val().length <= 0 || checkOutDate.val().length <= 0) {
                return;
            }

            checkInDate.removeClass('invalid');
        }

        let handleCoutChange = function () {
            if (typeof checkInDate.val() === 'undefined' || typeof checkOutDate.val() === 'undefined') {
                return;
            }

            if (checkInDate.val().length <= 0 || checkOutDate.val().length <= 0) {
                return;
            }

            bookingDateError.addClass('hide');
            checkOutDate.removeClass('invalid');
        }

        let getAvailableLodges = function () {
            if (typeof checkInDate.val() === 'undefined' || typeof checkOutDate.val() === 'undefined' || typeof numGuests.val() === 'undefined') {
                return;
            }

            if (checkInDate.val().length <= 0 || checkOutDate.val().length <= 0 || numGuests.val().length <= 0) {
                return;
            }

            let cinDate = new Date(checkInDate.val());
            let coutDate = new Date(checkOutDate.val());

            if (cinDate.getTime() >= coutDate.getTime()) {
                checkOutDate.addClass('invalid');
                bookingDateError.html("Check out must be before check in.");
                bookingDateError.removeClass('hide');
                return;
            }

            let dayDiff = ( coutDate.getTime() - cinDate.getTime() ) / (1000 * 3600 * 24);
            if (dayDiff > 10) {
                checkOutDate.addClass('invalid');
                bookingDateError.html("Check out must be less than 10 days after check in.");
                bookingDateError.removeClass('hide');
                return;
            }

            if (numGuests.val() === 'Select...') {
                return;
            }

            let query = [];
            let checkInDateVal = checkInDate.val();
            let checkOutDateVal = checkOutDate.val();
            let numGuestsVal = numGuests.val();

            query.push('category_ids=18'); // 18: lodges category
            query.push('min_date='+encodeURIComponent(checkInDateVal));
            query.push('max_date='+encodeURIComponent(checkOutDateVal));
            query.push('num_guests='+encodeURIComponent(numGuestsVal));

            let url = wpApiSettings.root + 'kishmish/wc-bookings/v1/products/slots?'+query.join('&');

            // TODO: disable input fields
            $('.loading-overlay').show();
            addToCart.addClass('disabled');

            $.ajax({
                url: url,
                type: "GET",
                // beforeSend: function (xhr) {
                //     xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
                // },
                statusCode: {
                    400: function(j, s, e) {
                        if (typeof j.responseJSON.message !== 'undefined' && j.responseJSON.message.length > 0) {
                            console.error(j.responseJSON.message);
                        }
                    },
                    500: function(j, s, e) {
                        if (typeof j.responseJSON.message !== 'undefined' && j.responseJSON.message.length > 0) {
                            console.error(j.responseJSON.message);
                        }
                    }
                },
                complete: () => {
                    $('.loading-overlay').hide();
                }
            }).done(function(r) {
                let records = r.records;

                let post_costs = {};
                let booked_post_ids = [];
                let available_post_ids = [];

                for (let i = 0; i < records.length; i++) {
                    let product_id = records[i].product_id;
                    if (product_id in post_costs) {
                        post_costs[product_id] += records[i].price;
                    } else {
                        post_costs[product_id] = records[i].price;
                    }

                    if (booked_post_ids.indexOf(product_id) !== -1) {
                        continue;
                    }

                    let available = records[i].available;
                    let idx_available = available_post_ids.indexOf(product_id);

                    if (available <= 0) {
                        booked_post_ids.push(product_id);

                        if (idx_available !== -1) {
                            available_post_ids.splice(idx_available, 1);
                            i--;
                        }
                    } else if (idx_available === -1) {
                        available_post_ids.push(product_id);
                    }
                }

                let available_classes = available_post_ids.map(function(e) {
                    $('button[value="'+e+'"]').removeClass('disabled');
                    $('.post-id-'+e+'.guest-'+numGuests.val() + ' .woocommerce-Price-amount').html('$' + post_costs[e].toFixed(2));
                    $('.post-id-'+e+'.guest-'+numGuests.val() + ' .rate-description').hide();
                    return '.post-id-'+e+'.guest-'+numGuests.val();
                })

                if (available_classes.length > 0) {
                    // Set hidden form fields
                    let checkInDateParts = checkInDate.val().split('-');
                    checkInYear.val(checkInDateParts[0]);
                    checkInMonth.val(checkInDateParts[1]);
                    checkInDay.val(checkInDateParts[2]);
                    numPersons.val(numGuests.val());

                    let dayDiff = ( coutDate.getTime() - cinDate.getTime() ) / (1000 * 3600 * 24);
                    stayDuration.val(dayDiff);

                    // Filter ui cards
                    mixer.filter(available_classes.join(', ')).then(function() {
                        $('text').hide();
                        setTimeout(function() { $('text').show(); }, 20);
                    });
                    $('.lodge-empty').hide();
                } else {
                    $('.lodge-empty').show();
                    mixer.hide();
                }

            });
        };

        checkInDate.change(handleCinChange);
        checkInDate.change(getAvailableLodges);
        checkOutDate.change(handleCoutChange);
        checkOutDate.change(getAvailableLodges);
        numGuests.change(getAvailableLodges);

        const submitForm = function(e) {
            if ($(this).hasClass('disabled')) {
                e.preventDefault();
                return;
            }

            productIdField.val($(this).val());

            bookingForm.submit();
        };

        addToCart.click(submitForm);
    });
})(jQuery);
